import { createReducer } from 'redux-act';
import {
  TEMPLATE_FETCH_DATA_INIT,
  TEMPLATE_FETCH_DATA_SUCCESS,
  TEMPLATE_FETCH_DATA_FAIL,
  TEMPLATE_SEARCH_INIT,
  TEMPLATE_SEARCH_SUCCESS,
  TEMPLATE_SEARCH_FAIL,
  TEMPLATE_FILTER_BY_SCREEN_INIT,
  TEMPLATE_FILTER_BY_SCREEN_SUCCESS,
  TEMPLATE_FILTER_BY_SCREEN_FAIL,
  TEMPLATE_CREATE_INIT,
  TEMPLATE_CREATE_SUCCESS,
  TEMPLATE_CREATE_FAIL,
  TEMPLATE_UPDATE_INIT,
  TEMPLATE_UPDATE_SUCCESS,
  TEMPLATE_UPDATE_FAIL,
  TEMPLATE_DELETE_INIT,
  TEMPLATE_DELETE_SUCCESS,
  TEMPLATE_DELETE_FAIL,
  TEMPLATE_CLEAR_DATA,
  TEMPLATE_CLEAR_DATA_LOGOUT,
  TEMPLATE_CLEAN_UP,
  SET_TEMPLATE,
} from 'state/actions/template';

const initialState = {
  loading: false,
  list: [],
  searchResults: [],
  filteredResults: [],
  template: null,
  error: null,
};

export const templateReducer = createReducer(
  {
    [TEMPLATE_FETCH_DATA_INIT]: (state) => ({ ...state, loading: true }),
    [TEMPLATE_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      list: payload.list,
      template: payload.template,
      error: null,
    }),
    [TEMPLATE_FETCH_DATA_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [TEMPLATE_SEARCH_INIT]: (state) => ({ ...state, loading: true }),
    [TEMPLATE_SEARCH_SUCCESS]: (state, { searchResults }) => ({
      ...state,
      loading: false,
      searchResults,
      error: null,
    }),
    [TEMPLATE_SEARCH_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [TEMPLATE_FILTER_BY_SCREEN_INIT]: (state) => ({ ...state, loading: true }),
    [TEMPLATE_FILTER_BY_SCREEN_SUCCESS]: (state, { filteredResults }) => ({
      ...state,
      loading: false,
      filteredResults,
      error: null,
    }),
    [TEMPLATE_FILTER_BY_SCREEN_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [TEMPLATE_CREATE_INIT]: (state) => ({ ...state, loading: true }),
    [TEMPLATE_CREATE_SUCCESS]: (state, { template }) => ({
      ...state,
      loading: false,
      list: [...state.list, template],
      error: null,
    }),
    [TEMPLATE_CREATE_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [TEMPLATE_UPDATE_INIT]: (state) => ({ ...state, loading: true }),
    [TEMPLATE_UPDATE_SUCCESS]: (state, { template, id }) => ({
      ...state,
      loading: false,
      list: state.list.map((item) =>
        item._id === id ? { ...item, ...template } : item
      ),
      template: state.template?._id === id ? { ...state.template, ...template } : state.template,
      error: null,
    }),
    [TEMPLATE_UPDATE_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [TEMPLATE_DELETE_INIT]: (state) => ({ ...state, loading: true }),
    [TEMPLATE_DELETE_SUCCESS]: (state, { id }) => ({
      ...state,
      loading: false,
      list: state.list.filter((item) => item._id !== id),
      error: null,
    }),
    [TEMPLATE_DELETE_FAIL]: (state, { error }) => ({
      ...state,
      loading: false,
      error,
    }),

    [TEMPLATE_CLEAR_DATA]: (state) => ({
      ...state,
      list: [],
      template: null,
      error: null,
    }),
    [TEMPLATE_CLEAR_DATA_LOGOUT]: () => initialState,
    [TEMPLATE_CLEAN_UP]: (state) => ({ ...state, error: null }),
    [SET_TEMPLATE]: (state, { data }) => ({ ...state, template: data }),
  },
  initialState
);
